import type { TraWaitlistStatus } from '@/lib/api/traAdminClient';

const STATUS_CONFIG: Record<TraWaitlistStatus, { label: string; className: string }> = {
  pending:    { label: 'Pendiente',   className: 'bg-gray-100 text-gray-700' },
  selected:   { label: 'Seleccionado', className: 'bg-green-100 text-green-800' },
  rejected:   { label: 'Rechazado',   className: 'bg-error-100 text-error-700' },
  waitlisted: { label: 'En espera',   className: 'bg-amber-100 text-amber-800' },
};

export function TraWaitlistStatusBadge({ status }: { status: TraWaitlistStatus }) {
  const { label, className } = STATUS_CONFIG[status] ?? { label: status, className: 'bg-gray-100 text-gray-700' };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${className}`}>
      {label}
    </span>
  );
}
